/**
 * Query Keys for React Query
 * Centralized key management for cache invalidation
 */

export const queryKeys = {
    // Clients
    clients: {
        all: ['clients'] as const,
        list: (page?: number) => ['clients', 'list', page] as const,
        search: (term: string) => ['clients', 'search', term] as const,
        detail: (name: string) => ['clients', 'detail', name] as const,
        detailById: (id: string) => ['clients', 'detail', 'id', id] as const,
        birthdays: () => ['clients', 'birthdays'] as const,
        inactive: () => ['clients', 'inactive'] as const,
    },

    // Services/Earnings
    services: {
        all: ['services'] as const,
        pending: () => ['services', 'pending'] as const,
        pendingAll: () => ['services', 'pendingAll'] as const,
        pendingByEmployee: (employeeId: string) =>
            ['services', 'pendingAll', 'employee', employeeId] as const,
        clientPending: (clientId: string) => ['services', 'clientPending', clientId] as const,
        clientPendingByEmployee: (clientId: string, employeeId: string) =>
            ['services', 'clientPending', clientId, 'employee', employeeId] as const,
        paidToday: () => ['services', 'paidToday'] as const,
        allToday: () => ['services', 'allToday'] as const,
        clientServices: (clientName: string) => ['services', 'client', clientName] as const,
    },

    // Employees
    employees: {
        all: ['employees'] as const,
        activeList: () => ['employees', 'active', 'list'] as const,
        byEmail: (email: string) => ['employees', 'byEmail', email] as const,
        services: (employeeName: string, start: string, end: string, department?: string) =>
            ['employees', 'services', employeeName, start, end, department] as const,
        payments: (employeeId: string, start: string, end: string) =>
            ['employees', 'payments', employeeId, start, end] as const,
        earnings: (employeeName: string, start: string, end: string) =>
            ['employees', 'earnings', employeeName, start, end] as const,
    },

    // Owner
    owner: {
        balances: () => ['owner', 'balances'] as const,
        pendingEarnings: () => ['owner', 'pendingEarnings'] as const,
        commissions: (startIso: string, endIso: string) =>
            ['owner', 'commissions', startIso, endIso] as const,
        professionalServices: (name: string, startIso: string, endIso: string) =>
            ['owner', 'professionalServices', name, startIso, endIso] as const,
        dailyServices: (dateIso: string) => ['owner', 'dailyServices', dateIso] as const,
        flowData: (startIso: string, endIso: string) =>
            ['owner', 'flowData', startIso, endIso] as const,
    },

    // Audit Trail
    audit: {
        all: ['audit'] as const,
        logs: (filters: {
            pageNumber?: number;
            searchTerm?: string | null;
            actionFilter?: string | null;
            entityFilter?: string | null;
            actorFilter?: string | null;
            startDate?: string | null;
            endDate?: string | null;
        }) =>
            [
                'audit',
                'logs',
                filters.pageNumber,
                filters.searchTerm,
                filters.actionFilter,
                filters.entityFilter,
                filters.actorFilter,
                filters.startDate,
                filters.endDate,
            ] as const,
    },
};
